export default function () {
  return [{
    label: '首页',
    name: 'homePage'
  }, {
    label: '通知公告',
    name: 'notice'
  }, {
    label: '党建引领',
    name: 'party_lead'
  }, {
    label: '廉洁园地',
    name: 'probity_garden'
  }, {
    label: '工会动态',
    name: 'union_news'
  }, {
    label: '青团之声',
    name: 'youth_league_voice'
  }, {
    label: '创业创新',
    name: 'pioneer_innovation'
  }, {
    label: '文化阵地',
    name: 'culture_position'
  }, {
    label: '榜样力量',
    name: 'model_strength'
  }, {
    label: '公益活动',
    name: 'public_benefit_activities'
  }]
}
